import { BottomWrapper, LeftColumn, Link, RightColumn, Text } from '../bottom.style'

export const Bottom = () => {
    return (
        <BottomWrapper>
            <LeftColumn>
                <Link href="/documents/aszf.pdf">Adatkezelési tájékoztató</Link>
                <Link href="/documents/aszf.pdf">Általános szerződési feltételek</Link>
                <Link href="/documents/impresszum.pdf">Impresszum</Link>
            </LeftColumn>
            <RightColumn>
                <Text>Minden jog fenntartva a MASZK társulat számára</Text>
            </RightColumn>
        </BottomWrapper>
    )
}
